"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SubscribeModule = _interopRequireDefault(require("./Subscribe.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//import * as firebase from 'firebase/app';
// import { Grommet, Box } from 'grommet';
var Subscribe = /*#__PURE__*/function (_React$Component) {
  _inherits(Subscribe, _React$Component);

  var _super = _createSuper(Subscribe);

  function Subscribe(props) {
    var _this;

    _classCallCheck(this, Subscribe);

    _this = _super.call(this, props);
    _this.state = {
      subscribed: false,
      mailingList: {}
    };
    _this.subscribeButton = _this.subscribeButton.bind(_assertThisInitialized(_this));
    _this.reSubscribe = _this.reSubscribe.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Subscribe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.mailingList[this.props.token] !== undefined) {
        this.setState({
          subscribed: true,
          mailingList: JSON.parse(JSON.stringify(this.props.mailingList))
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (JSON.stringify(this.props.mailingList) !== JSON.stringify(this.state.mailingList)) {
        this.setState({
          subscribed: this.props.mailingList[this.props.token] !== undefined,
          mailingList: JSON.parse(JSON.stringify(this.props.mailingList))
        });
      }
    }
  }, {
    key: "subscribeButton",
    value: function subscribeButton() {
      this.props.editMailingList(true, this.props.clubUUID, this.props.email, function () {}, true);
    }
  }, {
    key: "reSubscribe",
    value: function reSubscribe() {
      this.props.editMailingList(false, this.props.clubUUID, this.props.email, function () {}, true);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.subscribed) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].padding
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].outer_div,
          style: {
            background: "#5BE7C3"
          }
        }, /*#__PURE__*/_react["default"].createElement("img", {
          id: _SubscribeModule["default"].subscribed_icon,
          src: staticImages.SUBSCRIBED,
          alt: "subscribed icon"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].subscribe_text,
          style: {
            color: "#ffffff",
            left: "calc(6.325% + 24px)"
          }
        }, "Subscribed"), /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].get_email_updates,
          style: {
            color: "#ffffff"
          }
        }, "You are Getting Email Updates & Joining Info"), /*#__PURE__*/_react["default"].createElement("img", {
          id: _SubscribeModule["default"].undo,
          src: staticImages.UNDO,
          onClick: this.reSubscribe,
          alt: "undo icon"
        })));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].padding
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].outer_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].subscribe_text
        }, "Subscribe to our Email List"), /*#__PURE__*/_react["default"].createElement("div", {
          id: _SubscribeModule["default"].get_email_updates
        }, "Get Email Updates & Joining Info"), /*#__PURE__*/_react["default"].createElement("img", {
          id: _SubscribeModule["default"].subscribe_icon,
          src: staticImages.SUBSCRIBE,
          onClick: this.subscribeButton,
          alt: "subscribe icon"
        })));
      }
    }
  }]);

  return Subscribe;
}(_react["default"].Component);

var _default = Subscribe;
exports["default"] = _default;

//# sourceMappingURL=Subscribe.js.map